export function price(value: number, symbol: string) {
  return `${value.toLocaleString()} ${symbol}`
}
